export const INIT_DYNAMIC_PACKAGE_RESERVATION =
  "INIT_DYNAMIC_PACKAGE_RESERVATION";
export const INIT_DYNAMIC_PACKAGE_RESERVATIONS =
  "INIT_DYNAMIC_PACKAGE_RESERVATIONS";
